/**
 * 企业API配置
 * lixian
 */
const api = [
    {
      name: 'orgList',
      method: 'GET',
      desc: '会员列表',
      path: '/getOrgList',
      mock: false,
      params: {
        pageNum: 1,
        pageSize: 25,
        orgName: '',
        adminName: '',
        adminMobile: '',
        dataStatus: null
      }
    },
    {
      name: 'sysCrmMember',
      method: 'GET',
      desc: '会员详细信息',
      path: '/getOrgInfo',
    },
    {
      name: 'sendModifyOrgInfo',
      method: 'POST',
      desc: '信息修正',
      path: '/sendModifyOrgInfo',
    }
  ]
   
   export default {
     BASE_URL: '/org',
     NAMESPACE: 'orgMember',
     api
   }
   


// WEBPACK FOOTER //
// ./src/api/apis/member/org-query.js